import { ChipTypeEnums } from 'constants/enums';

/**
 * Processes chips array and categorizes them by type
 * Centralizes chip processing logic to avoid duplication across services
 * 
 * @param {Array} chips - Array of chip objects with chipType, id, and value properties
 * @returns {Object} Categorized chips object with arrays for each type
 */
export const processChipsForAPI = (chips = []) => {
  const chipsByType = {
    siteDepartmentIds: [],
    siteAssetIds: [],
    modelIds: [],
    modelTypeIds: [],
    userIds: [],
    serviceWorkOrders: [],
    defectWorkOrders: [],
    systemIds: [],
    intervals: [],
    roles: [],
    statuses: [],
    defectStatusIds: [],
    defectTypeIds: [],
    defectRiskRatingIds: [],
    textSearches: []
  };

  if (!Array.isArray(chips)) {
    return chipsByType;
  }

  chips.forEach(chip => {
    switch (chip.chipType) {
      case ChipTypeEnums.SiteDepartmentID:
        if (chip.id) chipsByType.siteDepartmentIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.SiteAssetID:
        if (chip.id) chipsByType.siteAssetIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.ModelID:
        if (chip.id) chipsByType.modelIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.ModelTypeID:
        if (chip.id) chipsByType.modelTypeIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.UserID:
        if (chip.id) chipsByType.userIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.ServiceWorkOrder:
        if (chip.value) chipsByType.serviceWorkOrders.push(chip.value);
        break;
      case ChipTypeEnums.DefectWorkOrder:
        if (chip.value) chipsByType.defectWorkOrders.push(chip.value);
        break;
      case ChipTypeEnums.DefectStatusID:
        if (chip.id) chipsByType.defectStatusIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.DefectTypeID:
        if (chip.id) chipsByType.defectTypeIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.DefectRiskRatingID:
        if (chip.id) chipsByType.defectRiskRatingIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.DefectSystemID:
        if (chip.id) chipsByType.systemIds.push(parseInt(chip.id));
        break;
      case ChipTypeEnums.Interval:
        if (chip.value) chipsByType.intervals.push(chip.value);
        break;
      case ChipTypeEnums.Role:
        if (chip.value) chipsByType.roles.push(chip.value);
        break;
      default:
        // Handle undefined chips and any unknown chip types as text searches
        if (chip.value) chipsByType.textSearches.push(chip.value);
        break;
    }
  });

  return chipsByType;
};
